// extracted by mini-css-extract-plugin
export default {"premium_partners__container":"PremiumPartnersContainer_premium_partners__container__R2eht"};